<template>
  <Layout
    :onlyLogoHeader="true"
    :showMenu="true"
    :showTopBar="false"
  >
    <div class="flex-grow-1">
      <div style="height: 105px;" class="d-flex align-center">
          <div
              @click="$router.push({ name: routeNames.TOKENS, params: {selectedTab: 'benefits'} })"
              class="circle d-flex justify-center align-center"
          >
              <v-icon
                  size="30"
                  color="#000230"
              >
                  {{ "arrow_back" }}
              </v-icon>
          </div>
      </div>
      <v-card elevation="0" style="background: #0002300D;" class="py-4 px-6 semi-rounded mt-12">
        <div style="color: var(--primary-color-blue) !important;" class="d-flex flex-column font-weight-light">
            <div
            class="d-flex justify-center align-center font-weight-medium mb-4"
            style="font-size: 13px"
          >
            <icon
                width="22"
                name="discount_coupon"
                color="#000230"
            ></icon>
            <div
              class="flex-grow-1 subtitle-1 font-weight-bold d-flex align-center justify-end"
            >
              <span>{{ discountCoupon.name }}</span>
            </div>
            <div
              class="flex-grow-1 subtitle-1 font-weight-bold d-flex align-center justify-end"
              style="color: #17ABCB;"
            >
              <span>{{ amount }}</span>
            </div>
          </div>
        </div>

        <div style="border: 1px solid white"></div>

        <div style="color: var(--primary-color-blue) !important;" class="d-flex flex-column font-weight-light">
            <div class="d-flex justify-space-between align-center font-weight-medium mb-4" style="font-size: 13px">
                <div class=" subtitle-1 font-weight-bold d-flex flex-column">
                    <span style="font-size: 12px; font-weight: 300;">{{$t("discount_coupon.expiration")}}</span>
                    <span>{{ formattedDate }}</span>
                </div>
                <div class=" subtitle-1 font-weight-bold d-flex flex-column">
                    <span style="font-size: 12px; font-weight: 300;">{{$t("discount_coupon.uses")}}</span>
                    <span>{{ uses }}</span>
                </div>
            </div>
        </div>

        <div style="border: 1px solid white"></div>

        <div style="color: var(--primary-color-blue) !important;" class="d-flex flex-column font-weight-light mt-4">
            <div class="d-flex justify-space-between align-center font-weight-medium mb-4" style="font-size: 13px">
                <span style="font-size: 12px; font-weight: 300;">{{$t("discount_coupon.applicable_products")}}</span>
            </div>
            <div v-for="(productId, i) in discountCoupon.products" :key="i" class="d-flex justify-space-between align-center font-weight-medium mb-4" style="font-size: 13px">
                <span>{{getProduct(productId).name}}</span>
            </div>
        </div>
      </v-card>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/MainLayout.vue";
import routeNames from "@/router/route-names";
import { mapState } from "vuex";


export default {
  props: {
    discountCoupon: {
      type: Object,
    },
  },
  data() {
    return {
      routeNames: routeNames
    };
  },
  components: { 
    Layout
  },
  computed: {
    ...mapState({
      customization: (state) =>
        state.customization.customization,
    }),
    amount() {
        if (this.discountCoupon.type == "PERCENTAGE") {
            return (this.discountCoupon.value/100) + "%" 
        }else{
            return (this.discountCoupon.value/100) +" "+ this.customization.economics.currency 
        }
    },
    formattedDate() {
        if(this.discountCoupon.expire_at != null) {
            const date = moment(this.discountCoupon.expire_at).locale(navigator.language);
            return date.format("DD/MM/YYYY");
        }else{
            return "-"
        }
    },
    uses() {
        if(this.discountCoupon.max_uses != null) {
            let currentUses = this.discountCoupon.used_counter != null ? this.discountCoupon.used_counter : 0
            return currentUses+"/"+this.discountCoupon.max_uses
        }else{
            return "-"
        }
    }
  },
  methods: {
    getProduct(productId) {
        const product = this.customization.products.find(p => p.id == productId)
        if (product != null) {
            return product
        }else{
            return {
                icon: null,
                id: productId,
                name: productId
            }
        }
    }
  }
};
</script>

<style scoped>
.circle {
  width: 52px !important;
  height: 52px !important;
  background-color: #0002300D !important;
  border-radius: 50% !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
